import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../../styles";
import {PDFContext} from "../../BasePDF";


export const FinanceDealerRateInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    return (
        <View style={{...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Rate Information</Text>
            </View>

            <View>

                <View style={baseStyles.flexBetween}>
                    <Text style={baseStyles.flex}>
                        APR
                    </Text>
                    <Text>{pdfData.apr}%</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text style={baseStyles.flex}>
                        Reserve Profit
                    </Text>
                    <Text>{pdfData.reserve_profit.toDollarFormat()}</Text>
                </View>

                <View style={baseStyles.flexBetween}>
                    <Text style={baseStyles.flex}>
                        Sell Rate
                    </Text>
                    <Text>{pdfData.disclosed_rate}</Text>
                </View>

            </View>
        </View>
    )
}